import Anchor from "components/Anchor/Anchor";
import getRelativeUrl from "helpers/getRelativeUrl";
import React, { FunctionComponent } from "react";
import Moment from "react-moment";
import styles from "./ResultCard.module.scss";
import ResultCardProps from "./ResultCardProps.interface";

const ResultCard: FunctionComponent<ResultCardProps> = (props) => {
    return (
        <Anchor className={styles.wrapper} to={getRelativeUrl(props.content._url)}>
            {/* Date */}
            {props.content.date ? (
                <p className={styles.date}>
                    <Moment parse="YYYY-MM-DDTHH:mm:ss" format="DD. MMM YYYY">{props.content.date}</Moment>
                </p>
            ) : null}

            {/* Name */}
            {props.content._name ? (
                <h1 className={styles.title}>{props.content._name}</h1>
            ): null}

            {/* Summary */}
            {props.content.pageExcerpt ? (
                <p className={styles.text}>{props.content.pageExcerpt}</p>
            ) : null}
        </Anchor>
    );
};

export default ResultCard;
